import * as React from "react";
import { SVGProps, memo } from "react";
const SvgTable12Px = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    fill="none"
    role="img"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 5v1h2V5h1v1h2v1H8v1h2v1H8v1H7V9H5v1H4V9H2V8h2V7H2V6h2V5h1Zm2 2H5v1h2V7Z"
      fill="#666"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h8ZM2 5v5h8V5H2Zm0-1h8V2H2v2Z"
      fill="#666"
    />
  </svg>
);
const Memo = memo(SvgTable12Px);
export default Memo;
